class Queue<T> {
  private items: T[];
  private readonly maxSize?: number;

  constructor(init?: T[], maxSize?: number) {
    this.maxSize = maxSize;
    this.items = init ?? [];
    this.trim();
  }

  enqueue(element: T): void {
    this.items.push(element);
    this.trim();
  }

  dequeue(): T | null {
    return this.isEmpty() ? null : (this.items.shift() as T);
  }

  peek(): T | null {
    return this.isEmpty() ? null : this.items[0];
  }

  isEmpty(): boolean {
    return this.items.length === 0;
  }

  size(): number {
    return this.items.length;
  }

  clear() {
    this.items = [];
  }

  private trim(): void {
    if (this.maxSize === undefined) {
      return;
    }

    if (this.items.length > this.maxSize) {
      this.items.splice(0, this.items.length - this.maxSize);
    }
  }
}

export default Queue;
